export function isActive(href, pathname = location.pathname) {
  const p = (pathname || "/").replace(/\/+$/, "/");
  const h = (href || "/").replace(/\/+$/, "/");
  if (h === "/") return p === "/";
  return p.startsWith(h);
}
